


















import {
  defineComponent,
  PropType
} from '@nuxtjs/composition-api';
import useWindowScroll from '~/hooks/useScrollWindow';
import useActiveLink from '~/hooks/useActiveLink';

export default defineComponent({
  name: 'StickyPDPNavigation',
  props: {
    links: {
      type: Array as PropType<{ href: string; text: string }[]>,
      required: true,
      default: () => []
    }
  },
  setup(props) {
    const { activeLink } = useActiveLink(props.links);
    const DISPLAY_OFFSET = 900;
    const { passedThreshold: isShown } = useWindowScroll(DISPLAY_OFFSET);

    return {
      activeLink,
      isShown
    };
  }
});
